// extracted by mini-css-extract-plugin
export var link = "_ta-0";